export default "__VITE_ASSET__d31a7722__"